export default "__VITE_ASSET__AR0Q1Wx3__";